import React from 'react';
import Debounce from 'react-debounce-component';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import { MultipleProductSelectionForColor } from '../multiple-product-selection-for-color';
import classes from './giveaway-multiple-products-selection.scss';
import animationClasses from './appear.anim.scss';
export function GiveawayMultipleProductsSelectionComponent({
  colorVariants,
  product
}) {
  function onSectionClick(e) {
    return e.stopPropagation();
  }
  const latestSelectedIndex = colorVariants.reduce((resultIndex, variant, index) => {
    if (variant.isSelected) {
      return index;
    }
    return resultIndex;
  }, -1);
  return /*#__PURE__*/React.createElement("div", {
    onClick: onSectionClick,
    className: classes.selectionSection
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    in: latestSelectedIndex !== -1,
    classNames: animationClasses,
    unmountOnExit: true,
    timeout: 200
  }, /*#__PURE__*/React.createElement(Debounce, {
    ms: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.forMobile, classes.selectQuantityText)
  }, "Select your quantity:"))), colorVariants.map((selectedColorVariant, index) => {
    return /*#__PURE__*/React.createElement(MultipleProductSelectionForColor, {
      product: product,
      key: selectedColorVariant.colorValue,
      colorValue: selectedColorVariant.colorValue,
      colorName: selectedColorVariant.colorName,
      colorVariantId: selectedColorVariant.colorVariantId,
      parentId: String(selectedColorVariant.parentId),
      selectedQuantitiesInfo: selectedColorVariant.selectedQuantities,
      errors: selectedColorVariant.errors,
      isSelected: selectedColorVariant.isSelected,
      isLastSelected: index === latestSelectedIndex
    });
  }));
}